// removed by extract-text-webpack-plugin
module.exports = {"UserImage":"UserImage__UserImage__2vIM8","loading":"UserImage__loading__2-MSL","UserImageBox":"UserImage__UserImageBox__KIX4q"};


//////////////////
// WEBPACK FOOTER
// ./src/components/User/UserImage/UserImage.css
// module id = 404
// module chunks = 0